import { Badge, Btn } from "./UI";

export default function ApplicantsTab({
  jobs, applicants, selectedJob, loading,
  setSelectedJob, fetchApplicants, onReview,
}) {
  return (
    <div>
      {/* Header */}
      <div style={{ marginBottom: 24 }}>
        <h1 style={{ fontSize: 26, fontWeight: 800, color: "#0f172a", fontFamily: "'Playfair Display', serif", letterSpacing: "-0.4px" }}>
          Applicants
        </h1>
        {selectedJob && (
          <p style={{ color: "#64748b", marginTop: 4, fontSize: 14 }}>
            For: <strong style={{ color: "#0f172a" }}>{selectedJob.title}</strong> @ {selectedJob.company}
          </p>
        )}

        {/* Job selector */}
        <div style={{ marginTop: 16, display: "flex", gap: 8, flexWrap: "wrap", alignItems: "center" }}>
          <span style={{ fontSize: 13, color: "#64748b" }}>Select job:</span>
          {jobs.filter(j => (j.totalApplicants ?? 0) > 0).length === 0 ? (
            <span style={{ fontSize: 13, color: "#94a3b8", fontStyle: "italic" }}>No jobs with applicants yet.</span>
          ) : (
            jobs.filter(j => (j.totalApplicants ?? 0) > 0).map(j => (
              <button
                key={j._id}
                onClick={() => { setSelectedJob(j); fetchApplicants(j._id); }}
                style={{
                  padding: "7px 14px", borderRadius: 10, fontSize: 13, fontWeight: 600,
                  cursor: "pointer",
                  background: selectedJob?._id === j._id ? "#0f172a" : "#f1f5f9",
                  color:      selectedJob?._id === j._id ? "#fff"    : "#374151",
                  border: "none", fontFamily: "'DM Sans', sans-serif",
                  transition: "all 0.15s",
                }}
              >
                {j.title} ({j.totalApplicants})
              </button>
            ))
          )}
        </div>
      </div>

      {/* Content */}
      {!selectedJob ? (
        <div style={{
          textAlign: "center", padding: 80,
          background: "#fff", borderRadius: 20, border: "1px solid #f1f5f9",
        }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>👥</div>
          <div style={{ color: "#64748b" }}>Select a job above to view applicants.</div>
        </div>
      ) : loading ? (
        <div style={{ textAlign: "center", padding: 80, color: "#94a3b8" }}>
          <div style={{ fontSize: 32, marginBottom: 12 }}>⏳</div>
          Loading applicants…
        </div>
      ) : applicants.length === 0 ? (
        <div style={{
          textAlign: "center", padding: 80,
          background: "#fff", borderRadius: 20, border: "1px solid #f1f5f9",
        }}>
          <div style={{ fontSize: 48, marginBottom: 12 }}>📭</div>
          <div style={{ color: "#64748b" }}>No applicants yet for this position.</div>
        </div>
      ) : (
        <div style={{ display: "grid", gap: 12 }}>
          {applicants.map(app => {
            const snap = app.applicantSnapshot;
            const initials = (snap.currentRole || snap.name || "?").slice(0, 2).toUpperCase();
            return (
              <div key={app._id} style={{
                background: "#fff", borderRadius: 16, padding: "18px 22px",
                boxShadow: "0 1px 4px rgba(0,0,0,0.06)", border: "1px solid #f1f5f9",
                display: "flex", justifyContent: "space-between", alignItems: "flex-start",
                gap: 14, flexWrap: "wrap",
                transition: "box-shadow 0.2s",
              }}
                onMouseOver={e => (e.currentTarget.style.boxShadow = "0 4px 16px rgba(0,0,0,0.1)")}
                onMouseOut={e  => (e.currentTarget.style.boxShadow = "0 1px 4px rgba(0,0,0,0.06)")}
              >
                <div style={{ display: "flex", gap: 14, alignItems: "flex-start" }}>
                  {/* Avatar */}
                  <div style={{
                    width: 46, height: 46,
                    background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
                    borderRadius: 12, display: "flex", alignItems: "center",
                    justifyContent: "center", color: "#fff", fontSize: 16,
                    fontWeight: 800, flexShrink: 0, letterSpacing: "-0.5px",
                  }}>
                    {initials}
                  </div>

                  <div>
                    <div style={{ fontWeight: 700, color: "#0f172a", fontSize: 15 }}>
                      {snap.currentRole || "Applicant"}
                    </div>
                    <div style={{ fontSize: 13, color: "#64748b", marginTop: 2 }}>
                      📞 {snap.phone} &nbsp;·&nbsp; {snap.experience} exp
                    </div>
                    {app.agentNote && (
                      <div style={{ fontSize: 12, color: "#6366f1", marginTop: 5, fontStyle: "italic" }}>
                        📝 {app.agentNote}
                      </div>
                    )}
                    <div style={{ fontSize: 11, color: "#94a3b8", marginTop: 4 }}>
                      Applied {new Date(app.createdAt).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" })}
                    </div>
                  </div>
                </div>

                <div style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
                  <Badge status={app.status} />
                  <Btn size="sm" onClick={() => onReview(app)}>Review →</Btn>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}